var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifyEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.001,
    height: 14,
    viewBox: "0 0 14.001 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5471",
    "data-name": "Group 5471",
    transform: "translate(-1233 -559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pencil",
    d: "M13.39.635a2.086,2.086,0,0,0-2.949,0L1.5,9.572a.348.348,0,0,0-.081.128l-1.4,3.855a.35.35,0,0,0,.329.47A.357.357,0,0,0,.47,14l3.855-1.4a.357.357,0,0,0,.128-.081L13.39,3.584a2.086,2.086,0,0,0,0-2.949ZM4.013,11.971.936,13.089l1.119-3.076L9.813,2.255,11.77,4.213,4.013,11.971Zm8.881-8.882-.628.628L10.308,1.759l.628-.628a1.384,1.384,0,0,1,1.957,1.957Z",
    transform: "translate(1233 558.975)",
    fill: "#0923e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(1239 565)",
    fill: "#0923e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-right",
    d: "M6.648,5.891,4.8,4.045a.154.154,0,0,0-.218.218L6.168,5.846H1.154a.154.154,0,0,0,0,.308H6.168L4.584,7.737a.154.154,0,0,0,.218.218L6.648,6.108a.154.154,0,0,0,0-.218Z",
    transform: "translate(1239 563)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyEdit);
export default __webpack_public_path__ + "static/media/notify-edit.889a4ee5edd5b957a5887b7a37af7b2d.svg";
export { ForwardRef as ReactComponent };